import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, model: String }

  saveField(event) {
    const input = event.target
    const field = input.dataset.field
    const value = input.value

    if (!field || !this.urlValue) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ [this.modelValue]: { [field]: value } })
    }).then(response => {
      if (response.ok) {
        input.style.borderColor = "#D1FAE5"
        setTimeout(() => { input.style.borderColor = "transparent" }, 1000)
      } else {
        input.style.borderColor = "#FCA5A5"
        setTimeout(() => { input.style.borderColor = "transparent" }, 2000)
      }
    }).catch(() => {
      input.style.borderColor = "#FCA5A5"
      setTimeout(() => { input.style.borderColor = "transparent" }, 2000)
    })
  }
}
